// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"625fb8b1","453":"f9921b2e"}[chunkId] + ".chunk.js";
};